/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import {
	FormControl,
  Button,
  IconButton,
  FormControlLabel,
  Switch,
  Paper,
  Box
} from '@mui/material';
import { FilterList, ArrowUpward, ArrowDownward } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import { RootState } from '../../../../store/types';
import { IAutocompleteOption } from '../../../../models/iautocompleteOption';
import { ISite } from '../../../../models/isite';

type Props = {
  closeFiltersModal: CallableFunction,
}

const FiltersModal: React.FC<Props> = (props) => {
	const dispatch = useDispatch();

	const page = 1;
	const limit = 50;
	const orderBy = "name";
	const order = "asc";

	const [searchTextEquipment, setSearchTextEquipment] = useState<string>('');
	const [equipmentsFormated, setEquipmentsFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedEquipments, setSelectedEquipments] = useState<IAutocompleteOption[]>([]);

	const [searchTextPlace, setSearchTextPlace] = useState<string>('');
	const [placesFormated, setPlacesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedPlaces, setSelectedPlaces] = useState<IAutocompleteOption[]>([]);

	const [searchTextSite, setSearchTextSite] = useState<string>('');
	const [sitesFormated, setSitesFormated] = useState<ISite[]>([]);
	const [selectedSites, setSelectedSites] = useState<ISite[]>([]);

	const [searchTextGroup, setSearchTextGroup] = useState<string>('');
	const [groupsFormated, setGroupsFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedGroups, setSelectedGroups] = useState<IAutocompleteOption[]>([]);

  const [searchTextArea, setSearchTextArea] = useState<string>('');
	const [areasFormated, setAreasFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedAreas, setSelectedAreas] = useState<IAutocompleteOption[]>([]);

	const [searchTextCompanies, setSearchTextCompanies] = useState<string>('');
	const [companiesFormated, setCompaniesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedCompanies, setSelectedCompanies] = useState<IAutocompleteOption[]>([]);

	const initialStatus = {
		valid: false,
		validWithOpenedActions: false,
		invalid: {
			inDelay: false,
			notDone: false,
			hasNoServices: false,
			hasActionsOpenedOrOverdue: false,
			mixed: false
		},
		maintenance: false,
		inactive: false
	};

	const [status, setStatus] = useState(initialStatus);
	const [statusInvalidDropdown, setStatusInvalidDropdown] = useState<boolean>(false);
	const mixedCondition = (status.invalid.inDelay && status.invalid.notDone)
		|| (status.invalid.inDelay && status.invalid.hasActionsOpenedOrOverdue)
		|| (status.invalid.hasActionsOpenedOrOverdue && status.invalid.notDone);
  
  const fetchSites = useCallback(
    () => dispatch(actions.fetchSites(page, limit, searchTextSite, order, orderBy)),
    [page, limit, searchTextSite, order, orderBy]
  );

	const fetchPlaces = useCallback(
		() => dispatch(actions.createServiceFetchPlaces(selectedSites)),
		[selectedSites]
	);

	const fetchEquipmentsModels = useCallback(
		() => dispatch(actions.createServiceFetchEquipmentModels(page, limit, searchTextEquipment, order, orderBy)),
		[page, limit, searchTextEquipment, order, orderBy]
	);

	const fetchGroups = useCallback(
		() => dispatch(actions.createServiceFetchGroups(page, limit, searchTextGroup, order, orderBy)),
		[page, limit, searchTextGroup, order, orderBy]
	);

  const fetchAreas = useCallback(
		() => dispatch(actions.createServiceFetchAreas(page, limit, searchTextArea, order, orderBy)),
		[page, limit, searchTextArea, order, orderBy]
	);

	const fetchCompanies = useCallback(
		() => dispatch(actions.createServiceFetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
		[page, limit, searchTextCompanies, order, orderBy]
	);

	const role = useSelector((state: any) => state.auth.selectedAccess.role);
	const sites = useSelector((state: any) => state.sites.sites);
	const places = useSelector((state: RootState) => state.createService.places);
	const equipmentsModels = useSelector((state: RootState) => state.createService.equipmentModels);
	const groups = useSelector((state: RootState) => state.createService.groups);
	const areas = useSelector((state: RootState) => state.createService.areas);
	const companies = useSelector((state: RootState) => state.createService.companies);
  const filteredSites = useSelector((state: any) => state.sites.selectedSitesPlaces);
  const filteredPlaces = useSelector((state: RootState) => state.createService.equipmentTableFilters.filteredPlaces);
  const filteredEquipmentModels = useSelector((state: RootState) => state.createService.equipmentTableFilters.filteredModels);
  const filteredGroups = useSelector((state: RootState) => state.createService.equipmentTableFilters.filteredGroups);
  const filteredAreas = useSelector((state: RootState) => state.createService.equipmentTableFilters.filteredAreas);
  const filteredCompanies = useSelector((state: RootState) => state.createService.equipmentTableFilters.filteredCompanies);
  const filteredStatus = useSelector((state: RootState) => state.createService.equipmentTableFilters.filteredStatus);

	const loadingSites = useSelector((state: any) => state.sites.loading);
	const loadingEquipments = useSelector((state: RootState) => state.createService.equipmentModelsLoading);
	const loadingPlaces = useSelector((state: RootState) => state.createService.placesLoading);
	const loadingGroups = useSelector((state: RootState) => state.createService.groupsLoading);
	const loadingAreas = useSelector((state: RootState) => state.createService.areasLoading);
	const loadingCompanies = useSelector((state: RootState) => state.createService.companiesLoading);


	useEffect(() => {
		handleInputChangeSites(filteredSites);
		handleInputChangePlaces(filteredPlaces);
		handleInputChangeEquipments(filteredEquipmentModels);
		handleInputChangeGroups(filteredGroups);
		handleInputChangeAreas(filteredAreas);
		handleInputChangeCompanies(filteredCompanies);
		setStatus(filteredStatus);
	}, []);

	useEffect(() => {
		fetchPlaces();
	}, [selectedSites]);

	useEffect(() => {
		fetchSites();
	}, [searchTextSite]);

	useEffect(() => {
		fetchEquipmentsModels();
	}, [searchTextEquipment]);

	useEffect(() => {
		fetchGroups();
	}, [searchTextGroup]);

  useEffect(() => {
		fetchAreas();
	}, [searchTextArea]);

	useEffect(() => {
		if (role !== 'contractor') {
      fetchCompanies();
    }
	}, [searchTextCompanies]);

	useEffect(() => {
		setPlacesFormated(
			places.map((place) => ({ value: place._id, label: place.path }))
		)
	}, [places])

	useEffect(() => {
		setSitesFormated(
			sites.rows.map((site: ISite) => ({ value: site._id, label: site.name, ...site }))
		)
	}, [sites])

	useEffect(() => {
		setEquipmentsFormated(
			equipmentsModels.map((equipmentModel) => ({ value: equipmentModel._id, label: equipmentModel.name }))
		)
	}, [equipmentsModels])

	useEffect(() => {
		setGroupsFormated(
			groups.map((group) => ({ value: group._id, label: group.name }))
		)
	}, [groups])

  useEffect(() => {
		setAreasFormated(
			areas.map((area) => ({ value: area._id, label: area.name }))
		)
	}, [areas])

	useEffect(() => {
		setCompaniesFormated(
			companies.map((company) => ({ value: company._id, label: company.name }))
		)
	}, [companies])

	const handleInputChangeSelectorPlaces = (text: string) => {
		setSearchTextPlace(text);
	}

	const handleInputChangeSelectorSites = (text: string) => {
		setSearchTextSite(text);
	}

	const handleInputChangeSelectorEquipments = (text: string) => {
		setSearchTextEquipment(text);
	}

	const handleInputChangeSelectorGroups = (text: string) => {
		setSearchTextGroup(text);
	}

	const handleInputChangeSelectorAreas = (text: string) => {
		setSearchTextArea(text);
	}

	const handleInputChangeSelectorCompanies = (text: string) => {
		setSearchTextCompanies(text);
	}

	const handleInputChangeGroups = (selected: IAutocompleteOption[]) => {
		setSelectedGroups(selected);
	}

  const handleInputChangeAreas = (selected: IAutocompleteOption[]) => {
		setSelectedAreas(selected);
	}

	const handleInputChangePlaces = (selected: IAutocompleteOption[])=> {
		setSelectedPlaces(selected);
	}

	const handleInputChangeEquipments = (selected: IAutocompleteOption[]) => {
		setSelectedEquipments(selected);
	}

	const handleInputChangeCompanies = (selected: IAutocompleteOption[]) => {
		setSelectedCompanies(selected);
	}

	const handleInputChangeSites = (selected: ISite[]) => {
		if(selected) {
			setSelectedSites(
				selected.map(dt => ({ value: dt._id, label: dt.name, ...dt }))
			);
		} else {
			setSelectedSites([]);
		}
	}

	const handleClickFilter = () => {
		dispatch(actions.setCreateServiceEquipmentsTableFilters({
			filteredModels: selectedEquipments,
			filteredPlaces: selectedPlaces,
			filteredGroups: selectedGroups,
			filteredAreas: selectedAreas,
			filteredCompanies: selectedCompanies,
			filteredStatus: {
				...status,
				invalid: {
					...status.invalid,
					mixed: mixedCondition ? status.invalid.mixed : false
				}
			}
		}))
		dispatch(actions.setSitePlaces(selectedSites));
		props.closeFiltersModal();
	}

	const handleClickClearFilters = () => {
		setSelectedPlaces([])
		setSelectedEquipments([])
		setSelectedGroups([])
		setSelectedAreas([])
		setSelectedCompanies([])
		setStatus(initialStatus)
	}

	const handleChangeStatus = (key: string, value: boolean) => {
		if (key === 'invalid') {
			setStatus({
				...status,
				invalid: {
          mixed: status.invalid.mixed,
					inDelay: value,
					notDone: value,
					hasNoServices: value,
					hasActionsOpenedOrOverdue: value,
				}
			});
		} else if (key.includes('invalid.')) {
			const invalidKey = key.split('.')[1];
			setStatus({ ...status, invalid: { ...status.invalid, [invalidKey]: value } });
		} else {
			setStatus({ ...status, [key]: value });
		}
	};

	return (
		<Box sx={styles.container}>
			<Box sx={styles.headerContainer}>
				<Box sx={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList sx={{ marginRight: '1rem' }} />
					{i18n.t('filterListModalFilterEquip.text') as string}
					{
						((selectedPlaces && selectedPlaces.length > 0) ||	(selectedSites && selectedSites.length > 0)) && 
							<Box sx={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('filterListModalFilterEquip.clear') as string}</Box>
					}
				</Box>
				<IconButton onClick={() => props.closeFiltersModal()} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</Box>
			<Box sx={styles.bodyContainer}>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingSites}
						label={i18n.t('autocompleteModalFilterEquip.site')}
						data={sitesFormated}
						onSelectValue={handleInputChangeSites}
						valueSelected={selectedSites}
						newSearchText={handleInputChangeSelectorSites}
						id="site"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingEquipments}
						label={i18n.t('autocompleteModalFilterEquip.equipmentModel')}
						data={equipmentsFormated}
						onSelectValue={handleInputChangeEquipments}
						valueSelected={selectedEquipments}
						newSearchText={handleInputChangeSelectorEquipments}
						id="equipmentModel"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingGroups}
						label={i18n.t('autocompleteModalFilterEquip.groups')}
						data={groupsFormated}
						onSelectValue={handleInputChangeGroups}
						valueSelected={selectedGroups}
						newSearchText={handleInputChangeSelectorGroups}
						id="equipmentGroup"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingPlaces}
						label={i18n.t('autocompleteModalFilterEquip.place')}
						data={placesFormated}
						onSelectValue={handleInputChangePlaces}
						valueSelected={selectedPlaces}
						newSearchText={handleInputChangeSelectorPlaces}
						id="place"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingAreas}
						label={i18n.t('autocompleteModalFilterEquip.area')}
						data={areasFormated}
						onSelectValue={handleInputChangeAreas}
						valueSelected={selectedAreas}
						newSearchText={handleInputChangeSelectorAreas}
						id="area"
						isMulti
					/>
				</FormControl>
        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingCompanies}
            label={i18n.t('autocompleteModalFilterEquip.company')}
            data={companiesFormated}
            onSelectValue={handleInputChangeCompanies}
            valueSelected={selectedCompanies}
            newSearchText={handleInputChangeSelectorCompanies}
            id="company"
            isMulti
          />
        </FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					{i18n.t('autocompleteModalFilterEquip.status') as string}
					<FormControlLabel
						control={<Switch checked={status.valid} onChange={e => handleChangeStatus('valid', e.target.checked)} />}
						label={i18n.t('statusOptions.valid') as string}
					/>
					<FormControlLabel
						control={<Switch checked={status.validWithOpenedActions} onChange={e => handleChangeStatus('validWithOpenedActions', e.target.checked)} />}
						label={i18n.t('statusOptions.validWithOpenedActions') as string}
					/>
					<Box sx={{display: 'flex', alignItems: 'center'}}>
						<FormControlLabel
							control={
								<Switch
									checked={
										status.invalid.inDelay ||
										status.invalid.notDone ||
										status.invalid.hasNoServices ||
										status.invalid.hasActionsOpenedOrOverdue
									}
									onChange={e => handleChangeStatus('invalid', e.target.checked)}
								/>}
							label={i18n.t('statusOptions.invalid') as string}
						/>
						{statusInvalidDropdown
							? <IconButton onClick={() => setStatusInvalidDropdown(false)} size="large"><ArrowUpward/></IconButton>
							: <IconButton onClick={() => setStatusInvalidDropdown(true)} size="large"><ArrowDownward/></IconButton>}
					</Box>
					{statusInvalidDropdown &&
						<Box sx={{marginLeft: 20, display: 'flex', flexDirection: 'column'}}>
							<Paper
								sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 10 }}
								elevation={mixedCondition ? 1 : 0}
							>
								<Box sx={{display: 'flex', flexDirection: 'column'}}>
									<FormControlLabel
										control={<Switch checked={status.invalid.inDelay} onChange={e => handleChangeStatus('invalid.inDelay', e.target.checked)} />}
										label={i18n.t('statusOptions.inDelay') as string}
									/>
									<FormControlLabel
										control={<Switch checked={status.invalid.notDone} onChange={e => handleChangeStatus('invalid.notDone', e.target.checked)} />}
										label={i18n.t('statusOptions.notDone') as string}
									/>
									<FormControlLabel
										control={<Switch checked={status.invalid.hasActionsOpenedOrOverdue} onChange={e => handleChangeStatus('invalid.hasActionsOpenedOrOverdue', e.target.checked)} />}
										label={i18n.t('statusOptions.hasActionsOpenedOrOverdue') as string}
									/>
								</Box>
								{mixedCondition &&
									<FormControlLabel
										control={
											<Switch
												checked={status.invalid.mixed && mixedCondition}
												onChange={e => handleChangeStatus('invalid.mixed', e.target.checked)}
											/>
										}
										label={i18n.t('statusOptions.mixed') as string}
									/>
								}
							</Paper>
							<FormControlLabel
							sx={{paddingLeft: 10}}
								control={<Switch checked={status.invalid.hasNoServices} onChange={e => handleChangeStatus('invalid.hasNoServices', e.target.checked)} />}
								label={i18n.t('statusOptions.hasNoServices') as string}
							/>
						</Box>
					}
					<FormControlLabel
						control={<Switch checked={status.maintenance} onChange={e => handleChangeStatus('maintenance', e.target.checked)} />}
						label={i18n.t('statusOptions.maintenance') as string}
					/>
					<FormControlLabel
						control={<Switch checked={status.inactive} onChange={e => handleChangeStatus('inactive', e.target.checked)} />}
						label={i18n.t('statusOptions.inactive') as string}
					/>
				</FormControl>
			</Box>
			<Box sx={styles.footerContainer}>
				<Box
					onClick={() => props.closeFiltersModal()}
					sx={styles.buttonCancel}
				>
					{i18n.t('divModalFilterEquip.cancel') as string}
				</Box>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					sx={styles.button}
				>
					{i18n.t('divModalFilterEquip.ok') as string}
				</Button>
			</Box>
		</Box>
    );
}


const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: "space-between"
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: 10,
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem',
		marginLeft: '2rem',
		color: '#fff',
		cursor: 'pointer',
		textDecoration: 'underline'
	}
}

export default FiltersModal;
